// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cy-b";
export var colorBlue = "_cy-8";
export var colorDot = "_cy-0";
export var colorDotLarge = "_cy-2";
export var colorDotSmall = "_cy-1";
export var colorGreen = "_cy-7";
export var colorGrey = "_cy-3";
export var colorOrange = "_cy-5";
export var colorPink = "_cy-a";
export var colorPurple = "_cy-9";
export var colorRed = "_cy-4";
export var colorYellow = "_cy-6";